module.exports = __webpack_public_path__ + "img/bracken.13036206.jpg";